import _extends from "@babel/runtime/helpers/extends";
import { useMenu } from "@react-aria/menu";
import { mergeProps } from "@react-aria/utils";
import { useTreeState } from "@react-stately/tree";
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { extractStylingProps } from "../../shared/propStyling";
import { StyledListBox } from "../internal/StyledListBox";
import { MenuItemRenderer } from "./MenuItem";
const MenuRootWithRef = /*#__PURE__*/forwardRef(MenuRoot);
export { MenuRootWithRef as MenuRoot };
function MenuRoot(_ref, forwardedRef) {
  let {
    autoFocus,
    children,
    isVirtualized,
    keyboardDelegate,
    onAction,
    onClose,
    onKeyDown,
    onKeyUp,
    shouldFocusWrap,
    ...restProps
  } = _ref;
  const menuRef = useRef(null);
  useImperativeHandle(forwardedRef, () => menuRef.current, [menuRef.current]);
  const [stylingProps, componentProps] = extractStylingProps(restProps);
  const treeState = useTreeState({
    children
  });
  const {
    menuProps
  } = useMenu({
    autoFocus,
    isVirtualized,
    keyboardDelegate,
    onAction,
    onClose,
    onKeyDown,
    onKeyUp,
    shouldFocusWrap
  }, treeState, menuRef);
  return /*#__PURE__*/React.createElement(StyledListBox.Root, _extends({}, stylingProps, mergeProps(componentProps, menuProps), {
    ref: menuRef
  }), [...treeState.collection].map(item => /*#__PURE__*/React.createElement(MenuItemRenderer, {
    key: item.key,
    item: item,
    treeState: treeState
  })));
}
//# sourceMappingURL=MenuRoot.js.map